import _typeof from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/typeof.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
export default {
  props: {
    vip: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    price: {
      type: [Object, String, Number],
      default: function _default() {
        return {};
      }
    },
    old: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    cusStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    priceType: {
      type: String,
      default: 'salePrice'
    }
  },
  watch: {
    price: {
      handler: function handler(val) {
        if (_typeof(val) == 'object') {
          var _val$memPriceList;
          if (this.vip && this.isLogin && val !== null && val !== void 0 && val.memPriceList && val !== null && val !== void 0 && (_val$memPriceList = val.memPriceList) !== null && _val$memPriceList !== void 0 && _val$memPriceList.length) {
            var _val$memPriceList$;
            this.value = val === null || val === void 0 || (_val$memPriceList$ = val.memPriceList[0]) === null || _val$memPriceList$ === void 0 ? void 0 : _val$memPriceList$.price;
          } else {
            this.value = val === null || val === void 0 ? void 0 : val.salePrice;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      value: 0
    };
  },
  computed: {
    /** @returns {object} */unitRule: function unitRule() {
      return this.$store.state.unitRule;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    setUnit: function setUnit(e) {
      var value = _typeof(e) == 'object' ? 0 : e || 0;
      if (this.unitRule.ways == 10) {
        return this.unitRule.symbol + '' + (Math.round(value * 100) / 100).toFixed(this.unitRule.digit);
      }
      if (this.unitRule.ways == 20) {
        return this.unitRule.symbol + '' + Math.floor(value);
      }
      if (this.unitRule.ways == 30) {
        return this.unitRule.symbol + '' + Math.ceil(value);
      }
    }
  }
};